<template>
  <div id="app">
    <span v-if="isIdle" />
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-twitlight.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: process.env.VUE_APP_BROWSER_TITLE === undefined ? '%s - Zion' : '%s - ' + process.env.VUE_APP_BROWSER_TITLE
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  mounted () {
    window.BusEvt.$on('is-playing-video', (status) => {
      // console.log(`playing video or download book event triggered: ${status}`)
      this.isPlayingVideo = status
    })
  },
  data () {
    return {
      isPlayingVideo: false
    }
  },
  computed: {
    isAuth () {
      if (this.$route.meta.unAuth === true) {
        return true
      } else {
        return false
      }
    },
    isIdle () {
      if (this.$route.meta.unAuth === true || this.isPlayingVideo) {
        return false
      } else {
        if (this.$store.state.idleVue.isIdle) {
          this.$store.dispatch('logout')
          delete localStorage.token
          // eslint-disable-next-line
          this.$router.push('/loggedoutinactivity')
        }
        return this.$store.state.idleVue.isIdle
      }
    }
  }
}
</script>
